__turbopack_context__.v({
  "amount": "TPd48q_amount",
  "container": "TPd48q_container",
  "donation": "TPd48q_donation",
  "message": "TPd48q_message",
  "noDonations": "TPd48q_noDonations",
  "seemore": "TPd48q_seemore",
  "title": "TPd48q_title",
});
